/**
 * Textes des blocs tarifs US — alignés sur HomePricing (/) et ROICalculatorPricing partnerMode (/partners).
 */

/** Section Subscriptions sur /dashboard et /partners/dashboard (US uniquement). */
export const US_DASHBOARD_SUBSCRIPTIONS_HEADING = 'Choose Your Subscription';

export const US_HOME_PRICING_SECTION = {
  title: 'Simple, Transparent Pricing',
  subtitle: 'Try with a single credit, then switch to the monthly plan that fits your volume.',
  standardTab: 'Matterport',
  droneTab: 'Matterport + drone clips',
  creditsInfo: '1 credit = 1 video · Credits valid for 6 months',
  walkthroughFeature: 'Walkthrough Video (Branded)',
  perVideo: 'per video',
} as const;

export const US_PARTNERS_PRICING_SECTION = {
  title: 'Simple, Transparent Pricing',
  subtitle: 'Try with a single credit, then switch to the monthly plan that fits your volume.',
  standardTab: 'Standard',
  droneTab: '+ drone clips',
  creditsInfo: '1 credit = 1 video · Credits valid for 6 months',
  walkthroughFeature: "Walkthrough Video (Branded) with client's logo",
  delivery: '24-hour delivery (Mon-Thu)',
  droneIncluded: 'drone clips included',
  buyExtra: 'Additional credits available',
  fridayOrders: 'Friday → delivered Monday',
  creditsPerMonthSuffix: 'credits/month',
  propertiesPerMonthUnit: 'videos/month',
  perProperty: 'per property',
  perMonthShort: '/mo',
} as const;

/* ─── Textes FR ─── */

export const FR_HOME_PRICING_SECTION = {
  title: 'Tarifs simples et transparents',
  subtitle: 'Essayez avec un crédit, puis passez au forfait mensuel adapté à votre volume.',
  standardTab: 'Matterport',
  droneTab: 'Matterport + drone',
  creditsInfo: '1 crédit = 1 vidéo · Crédits valables 6 mois',
  walkthroughFeature: 'Vidéo walkthrough (brandée)',
  perVideo: 'par vidéo',
} as const;

export const FR_PARTNERS_PRICING_SECTION = {
  title: 'Tarifs simples et transparents',
  subtitle: 'Essayez avec un crédit, puis passez au forfait mensuel adapté à votre volume.',
  standardTab: 'Standard',
  droneTab: '+ drone',
  creditsInfo: '1 crédit = 1 vidéo · Crédits valables 6 mois',
  walkthroughFeature: 'Vidéo walkthrough (brandée) avec le logo du client',
  perVideo: 'par bien',
} as const;

export const FR_PARTNER_VOLUME_PLANS: { standard: UsPartnerVolumePlanRow[]; drone: UsPartnerVolumePlanRow[] } = {
  standard: [
    { id: 'starter', properties: 3, perProperty: 95, price: 285, savings: '', popular: false },
    { id: 'professional', properties: 6, perProperty: 85, price: 510, savings: 'Éco. 11%', popular: true },
    { id: 'enterprise', properties: 9, perProperty: 80, price: 720, savings: 'Éco. 16%', popular: false },
  ],
  drone: [
    { id: 'starter', properties: 3, perProperty: 135, price: 405, savings: '', popular: false },
    { id: 'professional', properties: 6, perProperty: 125, price: 750, savings: 'Éco. 7%', popular: true },
    { id: 'enterprise', properties: 9, perProperty: 120, price: 1080, savings: 'Éco. 11%', popular: false },
  ],
};

export type UsPartnerVolumePlanRow = {
  id: 'starter' | 'professional' | 'enterprise';
  properties: number;
  perProperty: number;
  price: number;
  savings: string;
  popular: boolean;
};

/** Même grille que ROICalculatorPricing partnerMode (USD). */
export const US_PARTNER_VOLUME_PLANS: { standard: UsPartnerVolumePlanRow[]; drone: UsPartnerVolumePlanRow[] } = {
  standard: [
    { id: 'starter', properties: 3, perProperty: 95, price: 285, savings: '', popular: false },
    { id: 'professional', properties: 6, perProperty: 85, price: 510, savings: 'Save 11%', popular: true },
    { id: 'enterprise', properties: 9, perProperty: 80, price: 720, savings: 'Save 16%', popular: false },
  ],
  drone: [
    { id: 'starter', properties: 3, perProperty: 135, price: 405, savings: '', popular: false },
    { id: 'professional', properties: 6, perProperty: 125, price: 750, savings: 'Save 7%', popular: true },
    { id: 'enterprise', properties: 9, perProperty: 120, price: 1080, savings: 'Save 11%', popular: false },
  ],
};
